import Vue from "vue";
import Router from "vue-router";

import Wrapper from "./views/Wrapper/Wrapper";
import PreOrder from "./views/PreOrder/PreOrder";
import Products from "./views/Products/Products";
import Country from "./views/Country/Country";
import Enroll from "./views/Enroll/Enroll";
import Status from "./views/Status/Status";
import Order from "./views/Order/Order";
import Payment from "./views/Payment/Payment";
import Ideal from "./views/PaymentMethods/Ideal";
import Creditcard from "./views/PaymentMethods/Creditcard";
import PaymentLink from "./views/PaymentLink/Payment";
import PaymentLinkDone from './views/PaymentLink/Done';
import SubscriptionLink from './views/SubscriptionLink/Payment';
import SubscriptionCreditCard from './views/SubscriptionLink/CreditCard';
import PaymentFailed from './views/Payment/Failed';

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      component: Wrapper,
      children: [
        {
          path: "p/:id",
          name: "home",
          component: Country
        },
        {
          path: "pre-order",
          name: "pre-order",
          component: PreOrder
        },
        {
          path: "order/:secret",
          name: "order",
          component: Order
        },
        {
          path: "enroll/:slug",
          name: "enroll",
          component: Enroll
        },
        {
          path: "products/:id",
          name: "products",
          component: Products
        },
        {
          path: "country",
          name: "country",
          component: Country
        },
        {
          path: "done",
          name: "status",
          component: Status
        },
        {
          path: 'payment_done',
          name: 'link-done',
          component: PaymentLinkDone,
        },
        {
          path: 'payment_link/:id/:secret',
          name: 'payment-link',
          component: PaymentLink,
        },
        {
          path: 'subscription/:id/:secret',
          name: 'subscription-link',
          component: SubscriptionLink,
        },
        {
          path: "betaling/:id",
          name: "payment",
          component: Payment
        },
        {
          path: "ideal/:id",
          name: "ideal",
          component: Ideal
        },
        {
          path: "creditcard/:id",
          name: "creditcard",
          component: Creditcard
        },
        {
          path: 'subscription/creditcard',
          name: 'subscription-creditcard',
          component: SubscriptionCreditCard,
        },
        {
          path: 'failed',
          name: 'payment-falied',
          component: PaymentFailed,
        }
      ]
    },
    {
      path: "/",
      redirect: "home"
    },
    {
      path: "*",
      redirect: "/"
    }
  ]
});

router.beforeEach((to, from, next) => {
  next();
});

export default router;
